export default __webpack_public_path__ + "static/media/icon7.660ab36d.png";